export const doneCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M8 0a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m4.618 5.467L8.055 11.66a.675.675 0 0 1-.953.126L3.843 9.181a.666.666 0 1 1 .833-1.041l2.717 2.174 4.151-5.634a.668.668 0 0 1 1.169.111.67.67 0 0 1-.096.677z"/></svg>`,
    name: 'done-circle'
};